import React, { useEffect, useState } from "react";
import axios from "axios";
import "../../Styles/auth/auth.scss";
import apiConfig from "../../utilities/apiConfig.json";
import serverConfig from "../../utilities/serverConfig.json";
import { useNavigate } from "react-router-dom";
import isoEventLogo from "./../../assets/images/Logo/Logo-Pazirex-Blue.svg";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LoginStep from "../../utilities/functions/loginProcessStep";

const Login = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const [phoneNumber, setPhoneNumber] = useState("");

  const apiParams = {
    mobile: phoneNumber
  }

  const referrer_id = localStorage.getItem('referrer_id')

  if (referrer_id) {
    apiParams.referrer_id = referrer_id
  }

  const loginAPI = (e) => {
    e.preventDefault(); // Prevent form submission

    setLoading(true);
    axios
      .post(serverConfig.server.url + apiConfig.api.authControllers.login, apiParams)
      .then((response) => {
        setLoading(false);
        if (response.data.status === "success") {
          localStorage.setItem("tokenfa", response.data.data.token);
          localStorage.setItem("mobile", phoneNumber);
          response.data.data.verification_code &&
            toast.success("کد ارسالی " + response.data.data.verification_code);
          toast.success("پیامک حاوی کد تایید با موفقیت ارسال شد");
          navigate("/twofa");
        } else {
          if (typeof response.data.errors === 'string') {

            // remove the invalid referre_id and re-call the login route again
            if (response?.data?.errors === 'چنین سایتی وجود ندارد!') {
              localStorage.removeItem('referrer_id')
              loginAPI()
              return
            }

            toast.error(response.data.errors);
          } else {
            response.data.errors.forEach((element) => {
              toast.error(element);
            });
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error("Error making API call:", error);
      });
  };

  useEffect(() => {
    let step = LoginStep();
    if (step !== "OK" && step) {
      navigate(step);
    }
  }, []);

  return (
    <div>
      <div className="container-fluid d-flex pt-5 mt-5 justify-content-center">
        <div className="card-group auth-card">
          <div className="card">
            <div className="card-body">
              <img
                src={isoEventLogo}
                className="logo-img d-flex mx-auto my-5"
                alt="..."
              // srcSet={`${isoEventLogo25} 25w, ${isoEventLogo50} 50w, ${isoEventLogo100} 100w`} //             srcset="
              />

              <h5 className="card-title fs-18">ثبت نام یا ورود</h5>
              <p className="fs-14">
                لطفا شماره همراه خود را وارد کنید ، کد تأیید به این شماره پیامک
                خواهد شد.
              </p>
              <form onSubmit={loginAPI}>
                <input
                  type="tel"
                  className="form-control"
                  id="phoneNumber"
                  placeholder="شماره همراه"
                  value={phoneNumber}
                  onChange={(e) => {
                    setPhoneNumber(e.target.value);
                  }}
                  autoFocus
                />
                <button
                  className="btn btn-primary mt-4"
                  type="submit"
                  disabled={loading || !phoneNumber}
                >
                  تایید و دریافت کد
                  {loading && (
                    <span
                      className="spinner-border spinner-border-sm ms-1"
                      role="status"
                      aria-hidden="true"
                    />
                  )}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
